import React, { useEffect } from 'react';
import { RacingStream } from 'src/domains/sportsbook/webview/components/stream/RacingStream';
import { autorun } from 'mobx';
import { observer } from 'src/utils/mobx-react';
import { useCommon } from 'src/domains/common/Common';
import { StreamingState } from 'src/domains/sportsbook/state/streamingState/StreamingState';
import { RacingStreamGlobalState } from 'src/domains/sportsbook/webview/components/stream/RacingStreamGlobal.state';
import { RacingStreamRMG } from 'src/domains/sportsbook/webview/components/stream/RacingStreamRMG';

export interface RacingStreamGlobalPropsTypes {
    isRaceCard: boolean;
    isAnyCasinoPage: boolean;
    isNotificationsList: boolean;
}

export const RacingStreamGlobal = observer(
    'RacingStreamGlobal',
    (props: RacingStreamGlobalPropsTypes): JSX.Element | null => {
        const common = useCommon();
        const streamingState = StreamingState.get(common);
        const [state] = React.useState(() => new RacingStreamGlobalState(props, streamingState));

        useEffect(() => {
            const dispose = autorun(state.runObserve);
            return (): void => {
                dispose();
            };
        }, []);

        if (props.isRaceCard) {
            return null;
        }

        const { providerName } = streamingState;

        return providerName === 'RMG' ? (
            <RacingStreamRMG
                isNotificationsList={props.isNotificationsList}
                streamIsInViewport={false}
            />
        ) : (
            <RacingStream isNotificationsList={props.isNotificationsList} />
        );
    }
);
